<template>
  <div class="videos">
    <span id="t-add-up">
      <VideosAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <span id="n-send">
      <VideosSendNotification
        v-if="showNotify"
        :sendData="sendData"
        @close="closeNotify"
      />
    </span>
    <va-card :title="$t('videos.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#t-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="videos"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tooltips.send')}`" placement="bottom">
            <va-button
              flat
              color="red"
              href="#n-send"
              icon="fa fa-send-o"
              @click="notify(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('videos.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#t-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData.id)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('videos.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import VideosAddUpdate from './VideosAddUpdate'
import VideosSendNotification from './VideosSendNotification'

const perPage = 10
export default {
  name: 'videos',
  components: {
    VideosAddUpdate,
    VideosSendNotification,
  },
  methods: {
    notify (data) {
      this.showAdd = false
      this.sendData = data
      this.showNotify = true
    },
    closeNotify (v) {
      this.showNotify = v
      this.sendData = null
    },
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.showNotify = false
      this.updateData = null
      this.sendData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (id) {
      this.modalDeletar = true
      this.deleteId = id
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.videos.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_video_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      videos: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      sendData: null,
      userId: null,
      showNotify: false,
    }
  },
  apollo: {
    videos: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        videos: video(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          created_at
          title
          thumbnail
          file
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: video_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'title',
        title: this.$t('videos.headings.title'),
        width: '40%',
      }, {
        name: 'created_at',
        title: this.$t('videos.headings.created_at'),
        width: '20%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('videos')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.videos.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
